<template>
  <div
    class="c-player-popup"
    :class="[ isEmbedded ? 'c-player-popup--dark' : 'c-player-popup--light' ]"
  >
    <div class="c-player-popup__container">
      <button class="c-player-popup__circle">
        18<span>+</span>
      </button>
      <h5
        class="u-text-center u-ml-30 u-mr-30"
        :class="[ isEmbedded ? 'o-typography__headline4' : 'o-typography__headline2' ]"
      >
        {{ $t('player.adult.info') }}
      </h5>
      <h5
        v-if="isLoggedInUnderage"
        class="o-typography__headline4 u-text-center u-ml-30 u-mr-30"
      >
        {{ $t('player.adult.checkAccountInfo') }}
        <a
          href="/subscriber/my-account"
          target="_blank"
        >
          {{ $t('player.adult.checkAccountLink') }}
        </a>
      </h5>
    </div>
  </div>
</template>
<script>
  import { RouteName } from '@/shared/enums';
  import { NavigationContextManager } from '@/shared/utils/accessibility';

  export default {
    name: 'UiPlayerVerifyAge',
    props: {
      isEmbedded: {
        type: Boolean,
      },
      isLoggedInUnderage: {
        type: Boolean,
      },
    },
    enums: {
      RouteName,
    },
    mounted() {
      NavigationContextManager.pushContext(this.$el, () => {}, { savePrevFocus: true, skipFocus: true });
    },
    beforeDestroy() {
      NavigationContextManager.popContext();
    },
  };
</script>
